import {
  Directive,
  inject,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ChannelService } from '../services/channel.service';

@Directive({
  selector: '[showForChannels]',
  standalone: true,
})
export class ShowForChannelDirective implements OnInit {
  @Input('showForChannels') channels: string[] = [];

  private templateRef = inject(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private channelService = inject(ChannelService);

  ngOnInit(): void {
    const current = this.channelService.currentChannel;
    this.viewContainer.clear();

    if (this.channels.includes(current)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
